import moment from 'moment';

export function formatDateTime(dateString: string, dateWithTime?: boolean) {
  if (dateString) {
    if (dateWithTime) {
      //let as =
      let a: any = moment(dateString)
        .format('YYYY-MM-DD LTS')
        .replace(' ', '\n');
      return a;
    } else {
      return moment(dateString).format('YYYY-MM-DD');
    }
  } else {
    return '';
  }
}

export function formatMessageDateTime(dateString: string | null, dateWithTime?: boolean) {
  if (dateString) {
    if (dateWithTime) {
      let a = moment(dateString).format('YYYY-MM-DD');
      let b = moment(dateString).format('LTS');
      return `${a}\n${b}`;
    } else {
      return moment(dateString).format('YYYY-MM-DD');
    }
  } else {
    return '';
  }
}

export function formatDate(dateString: string | undefined) {
  if (dateString) {
    let a = moment(dateString).format('YYYY-MM-DD');
    return a;
  } else {
    return dateString;
  }
}

export function convertToStartDateString(dateString: string | undefined) {
  if (dateString) {
    let d = new Date(dateString);
    d.setUTCHours(0, 0, 0, 0);
    return d.toISOString();
  } else {
    return dateString;
  }
}

export function convertToEndDateString(dateString: string | undefined) {
  if (dateString) {
    let d = new Date(dateString);
    d.setUTCHours(23, 59, 59, 999);
    return d.toISOString();
  } else {
    return dateString;
  }
}

export function formatAmount(amount: string | number | undefined) {
  if (amount) {
    let a = 'Rs. ' + parseFloat(amount.toString()).toFixed(2);
    return a;
  } else {
    return 'Rs. ' + parseFloat('0').toFixed(2);
  }
}

export function currentDatAndTime() {
  const DATE = new Date();

  const dateNumber = DATE.getDate();
  const monthNumber = DATE.getMonth();
  const fullYear = DATE.getFullYear();
  const hours = DATE.getHours();
  const minutes = DATE.getMinutes();
  const seconds = DATE.getSeconds();

  const formattedDate = `${dateNumber < 10 ? '0' : ''}${dateNumber}${
    monthNumber < 10 ? '0' : ''
  }${monthNumber + 1}${fullYear}`;
  const formattedTime = `${hours < 10 ? '0' : ''}${hours}${minutes < 10 ? '0' : ''}${minutes}${
    seconds < 10 ? '0' : ''
  }${seconds}`;

  return `${formattedDate}_${formattedTime}`;
}
